import { GzChatNoticeWebComponent } from './component/GzChatNoticeWebComponent';

export { GzChatNoticeWebComponent };
